<script>
import Header from "@/views/Layout/Header.vue";
import Footer from "@/views/Layout/Footer.vue";

export default {
  name: "commonLayout",
  components: {Footer, Header},
}
</script>

<template>
<div class="layout">
  <Header/>
  <main class="main-content">
    <router-view />
  </main>
  <Footer/>
</div>
</template>

<style scoped>
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  width: 100%;
  transition: all 0.3s ease; /* 添加过渡效果，使页面切换更平滑 */
}
</style>